import React, { useState, useEffect } from 'react';

const useAutoCollection = (collection, dataSetter, canAdd, newItem) => {

    const [uniqueKey, setKey] = useState(0);

    updateCollection();

    useEffect(() => {
        const dataChanged = updateCollection();
        if (dataChanged) {
            const currentData = JSON.parse(JSON.stringify(collection));
            dataSetter(currentData);
        }
    },
        [collection]);

    function updateCollection() {
        //flag to check if we modified the collection so we can update the collection
        let dataChanged = false;

        const found = collection.filter((item) => {
            if (item['newItem']) return item;
        });

        if (!found.length) {
            const itemToAdd = JSON.parse(JSON.stringify(newItem));
            itemToAdd.newItem = true;
            collection.push(itemToAdd);
            dataChanged = true;
        }

        const itemsWithoutKeys = collection.filter((item) => item.reactKey === undefined);

        //set a react key property to track new items for all items that don't have a key
        if (itemsWithoutKeys.length > 0) {
            collection.forEach(item => {
                if (item.reactKey === undefined) {
                    item.reactKey = item.id !== 0 ? item.id : getMaxKey(collection) + 1;
                    dataChanged = true;
                }
            });
        }

        if (dataChanged) setKey(getMaxKey(collection));
        return dataChanged;
    }

    function getMaxKey(collection) {
        let maxKey = 0;
        for (let i = 0; i < collection.length; i++) {
            if (collection[i].reactKey > maxKey) maxKey = collection[i].reactKey;
        }
        return uniqueKey > maxKey ? uniqueKey : maxKey;
    }

    function itemChange({ target: { name, type, value, checked } }, index) {
        const currentData = [...collection];

        //remove any prefix before . to allow collection name for uncontrolled form use
        name = name.substring(name.indexOf('.') + 1);

        if (type === 'checkbox') {
            currentData[index][name] = checked;
        } else {
            currentData[index][name] = value;
        }

        delete currentData[index].newItem;
        dataSetter(currentData);
    }

    function itemDelete(index) {
        const currentData = [...collection];
        currentData.splice(index, 1);
        dataSetter(currentData);
    }

    return {
        currentKey: uniqueKey,
        itemChange,
        itemDelete
    }
}

export default useAutoCollection;